import React from 'react';
import CircularProgressIndicatorIndeterminate from 'components/CircularProgressIndicatorIndeterminate';
import { getContext } from 'common';
import Styled from './styles';

const DEFAULT_WRAPPER_PROPS = {
  tabIndex: 0,
  onFocus: event => event.preventDefault()
};

export interface ListItemProgressIndicatorProps extends React.ComponentPropsWithRef<'div'> {
  /** The size of the ProgressIndicator. A number will be interpreted to be in pixels. */
  size?: number | string;
  /** Any other style to apply to the list item wrapper. */
  style?: React.CSSProperties;
  /** Any styles to apply to the progress indicator wrapper. */
  contentStyle?: React.CSSProperties;
}

/** `ListItemProgressIndicator` is to be used as child of `List`. All other props will be provided to the CircularProgressIndicatorIndeterminate. */
const ListItemProgressIndicator = React.forwardRef<HTMLElement, ListItemProgressIndicatorProps>((props: ListItemProgressIndicatorProps, ref) => getContext(({ RTL }) => {
  const {
    size,
    style,
    contentStyle,
    ...otherProps
  } = props;
  const resolvedSize = typeof size === 'string' ? size : `${size}px`;
  return (
    <Styled.ListItemProgressIndicatorWrapper
      {...DEFAULT_WRAPPER_PROPS}
      ref={ref}
      RTL={RTL}
      style={style}
    >
      <Styled.ListItemProgressIndicatorContent width={resolvedSize} height={resolvedSize} style={contentStyle}>
        <CircularProgressIndicatorIndeterminate {...otherProps} />
      </Styled.ListItemProgressIndicatorContent>
    </Styled.ListItemProgressIndicatorWrapper>
  );
}));

ListItemProgressIndicator.displayName = 'ListItemProgressIndicator';

ListItemProgressIndicator.defaultProps = {
  size: '1.5rem',
  style: undefined,
  contentStyle: undefined,
};

export default ListItemProgressIndicator;
